import { fabric } from 'fabric';
import filter from 'lodash-es/filter';
import forEach from 'lodash-es/forEach';

const LudusPathGroup = fabric.util.createClass(fabric.Group, {
  type: 'ludusPathGroup',
  lockUniScaling: false,

  initialize(objects, options = {}, isAlreadyGrouped) {
    this.initialized = false;
    const pathGroupOptions = {
      ...options,
      ludus: {
        ...options.ludus,
      },
    };

    // some icons from iconsScout (but not only) contains hidden objects...
    // Resulting in very very big luds Pathgroup.
    // It's safe to remove this hidden objects (that we consider as a bug from the third party)
    const filteredObjects = filter(objects, o => o.visible === true);

    this.callSuper(
      'initialize',
      filteredObjects,
      pathGroupOptions,
      isAlreadyGrouped,
    );

    this.initialized = true;
  },

  _set(key, value) {
    this.callSuper('_set', key, value);

    if (!this.initialized) {
      return this;
    }

    if (key === 'tint') {
      if (!this.ludus.prevObjsFills) {
        this.ludus.prevObjsFills = this._objects.map(path => path.fill);
      }
      if (!this.ludus.prevObjsStrokes) {
        this.ludus.prevObjsStrokes = this._objects.map(path => path.stroke);
      }
      this.updateFilters();
    }

    return this;
  },

  updateFilters() {
    this.forEachObject((path, index) => {
      let fill;
      let stroke;
      if (this.tint) {
        fill = this.tint;
        stroke = this.tint;
      } else {
        fill = this.ludus.prevObjsFills[index];
        stroke = this.ludus.prevObjsStrokes[index];
      }
      if (path.fill) {
        if (fill && fill.colorStops) {
          path.set('fill', new fabric.Gradient(fill));
        } else {
          path.set('fill', fill);
        }
      }
      if (path.stroke) {
        if (stroke && stroke.colorStops) {
          path.set('stroke', new fabric.Gradient(stroke));
        } else {
          path.set('stroke', stroke);
        }
      }
    }, this);
  },

  toObject(propertiesToInclude = []) {
    const extraProps = ['tint', 'lockUniScaling'];
    // if (!this.tint) {
    //   this.ludus.prevObjsFills = undefined;
    //   this.ludus.prevObjsStrokes = undefined;
    // }
    return this.callSuper('toObject', propertiesToInclude.concat(extraProps));
  },
});

LudusPathGroup.fromObject = function fromObject(object, callback) {
  const options = fabric.util.object.clone(object, true);

  if (options.src) {
    // Fabric doesn't like when you have attribute=" " (so we remove the space)
    const src = options.src.replace('%22%20%22%', '%22%22%');
    delete options.src;
    fabric.loadSVGFromURL(src, objects => {
      const objectsWithoutImages = objects
        ? objects.filter(o => !o._originalElement)
        : [];
      fabric.util.enlivenObjects(objectsWithoutImages, enlivenedObjects => {
        const onlyVisibleObjs = objs => filter(objs, o => o.visible === true);
        // We need to first instantiate a group with all paths, so fabric computes
        // the dimensions for us. Then we call again `LudusPathGroup.fromObject`
        // so it goes through the normal deserialization flow.
        const convertToLudusPath = objs =>
          forEach(objs, o => {
            if (o.type === 'path') {
              o.set({ type: 'ludusPath' });
            }
          });
        const group = new fabric.Group(
          onlyVisibleObjs(convertToLudusPath(enlivenedObjects)),
        );
        const groupObject = group.toObject();
        const overridenOptions = {
          ...options,
          objects: groupObject.objects,
          width: groupObject.width,
          height: groupObject.height,
        };
        LudusPathGroup.fromObject(overridenOptions, callback);
      });
    });
  } else {
    fabric.util.enlivenObjects(options.objects, enlivenedObjects => {
      delete options.objects;
      if (callback)
        callback(new LudusPathGroup(enlivenedObjects, options, true));
    });
  }
};

export default LudusPathGroup;
